import React, {Component, Fragment} from 'react';
import {Checkbox, Row, Col, Input, Button, Tabs, Modal, Form} from 'antd';
import {StyledDetailsCard} from './style';
import {StyledSubscriptionCard} from "../user-profile/style";
const FormItem = Form.Item;



class DefaultsPage extends Component {

    state = {
        apiUrl: 'https://api.optionsedu.com/graphql'
    }

    componentWillMount() {

    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { form } = this.state
        return (
            <Fragment>
                <Row>
                    <Col sm={24}>
                        <StyledDetailsCard title="Trade Details">
                            <Form layout={'vertical'} onSubmit={this.handleSubmit}>
                                <FormItem>
                                    {getFieldDecorator('isTradeExecuted', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Trade Executed Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isRisk', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Risk Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isTradeSource', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Trade Source Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isMarketCondition', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Market Condition Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isFollowUp', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Follow Up Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isTradeTarget', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Trade Target Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isTradeRisk', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Trade Risk Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isMaxLoss', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Max Loss Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isMaxGain', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Max Gain Visible</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isShowPosition', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Show Position Greeks (This option will show greeks on the positions grid for how much the position will move.)</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isShowOption', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Show Option Greeks (This option will show greeks on the positions grids the option aione.)</Checkbox>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('isShowColors', {
                                        valuePropName: 'checked',
                                        defaultValue: false,
                                    })(
                                        <Checkbox>Show Colors</Checkbox>
                                    )}
                                </FormItem>
                            </Form>
                        </StyledDetailsCard>
                    </Col>
                </Row>
                <Row>
                    <StyledDetailsCard title="Trade Transaction Visible">
                        <Form layout={'vertical'} onSubmit={this.handleSubmit}>
                            <FormItem>
                                {getFieldDecorator('isFees', {
                                    valuePropName: 'checked',
                                    defaultValue: false,
                                })(
                                    <Checkbox>Fees Column</Checkbox>
                                )}
                            </FormItem>
                            <FormItem>
                                {getFieldDecorator('isMultiplier', {
                                    valuePropName: 'checked',
                                    defaultValue: false,
                                })(
                                    <Checkbox>Multiplier Column</Checkbox>
                                )}
                            </FormItem>
                        </Form>
                    </StyledDetailsCard>
                </Row>
            </Fragment>
        )
    }
}

const DefaultPage = Form.create()(DefaultsPage);
export default DefaultPage





// WEBPACK FOOTER //
// ./src/components/setup-and-settings/defaultPage.js